import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loading from "../assetLibComponents/Loading";
import { LuCalendarDays } from "react-icons/lu";
import { FaBroom } from "react-icons/fa";
import {
  ArrowLeft,
  Clipboard,
  Code,
  Display,
  Phone,
  PhoneFill,
  WindowDesktop,
} from "react-bootstrap-icons";
import Tab from "../Tab";
import chatBarSvg from "../../assets/chatBar.svg";
import chatBarUnSvg from "../../assets/chatBarUn.svg";
import chatBubbleSvg from "../../assets/chatBubble.svg";
import chatBubbleUnSvg from "../../assets/chatBubbleUn.svg";
import salespandaSS from "../../assets/salespandass.png";
import "./ChatDesign.css";
import { InformationCircleIcon } from "@heroicons/react/20/solid";

import { Combobox, Dialog, Switch, Transition } from "@headlessui/react";
import SimpleSelect from "../SimpleSelect";
import { useDispatch } from "react-redux";
import {
  addDisclamer,
  addGreetingMessage,
  addSuggestion,
  carouselImageSubmit,
  chatDesignData,
  fetchChatDesignData,
  fetchDesignScreenshot,
  greetingMessage,
  updateSuggestion,
} from "../../redux/actions/chatAiActions";
import { BsChatLeftText } from "react-icons/bs";
import { Fragment } from "react";
import { Mixpanel } from "../../Mixpanel";
import Toast from "../assetLibComponents/shared/Toast";
import { ChromePicker, SketchPicker } from "react-color";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { IoHelpBuoy } from "react-icons/io5";
import { LuMonitorPlay } from "react-icons/lu";
import { MdOutlineSupportAgent } from "react-icons/md";
import { fetchSelectedCalendar } from "../../redux/actions/settingActions";
import Toggle from "../Toggle";
import { BiLinkAlt } from "react-icons/bi";
import { CiCirclePlus } from "react-icons/ci";
import { FaList } from "react-icons/fa6";
import { AiOutlineSend } from "react-icons/ai";
import { IoIosAddCircleOutline } from "react-icons/io";
import { CheckIcon } from '@heroicons/react/24/outline'
import Cropper from "react-easy-crop";
import getCroppedImg from './cropImage'
import { RiImageAddLine } from "react-icons/ri";










function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ChatDesign = (props) => {
  const boxTypes = [
    { id: 1, name: "Rectangle" },
    { id: 2, name: "Tablet" },
  ];
  const colorTypes = [
    { id: 1, name: "Dark Mode" },
    { id: 2, name: "Light Mode" },
  ];
  const fontTypes = [
    { id: 1, name: "Inter" },
    { id: 2, name: "Roboto" },
    { id: 3, name: "Open Sans" },
    { id: 4, name: "Montserrat" },
    { id: 5, name: "Poppins" },
    { id: 6, name: "Nunito" },
    { id: 7, name: "Quicksand" },
    { id: 8, name: "Abel" },
  ];
  const chatType = [
    { id: 1, name: "Open" },
    { id: 2, name: "Close" },
  ];
  const firstButton = [
    { id: 1, name: "None" },
    { id: 2, name: "Calendar" },
    { id: 3, name: "Contact" },
    { id: 4, name: "Link" },
  ];
  const secondButton = [
    { id: 5, name: "None" },
    { id: 2, name: "Calendar" },
    { id: 3, name: "Contact" },
    { id: 4, name: "Link" },
  ];

  const dispatch = useDispatch();
  const designData = useSelector((state) => state.chatAi.designData);
  const greeting_data = useSelector((state) => state.chatAi.greeting_message);
  const designScreenshot = useSelector(
    (state) => state.chatAi.designScreenshot
  );
  const isLoading = useSelector((state) => state.chatAi.loading);
  const selectedData = useSelector((state) => state.setting.fetchSelectedCalendar);
  const [tabName, setTabName] = useState("Chat Bar");
  const [embeddModal, setEmbeddModal] = useState(false);
  const [embeddCode, setEmbeddCode] = useState("");
  const [ctaLink, setCtaLink] = useState("");
  const [selectedOption, setSelectedOption] = useState(
    designData?.type?.length > 0 ? designData?.type : "chatBot"
    );
  const [chatBubbleTabName, setChatBubbleTabName] = useState(selectedOption !== "chatBot"? "Bot Design":"Chat Bubble");
  const [section, setSection] = useState(false);
  const [chatBarData, setChatBarData] = useState({
    //  section:false,
    sectionColour: "",
    sectionHeight: "",
    backgroundColour: "",
    borderColour: "",
    width: "",
    //  colorMode:"",
    //  primaryColour:"",
    //  placeholderText:"",
    //  boxShape:"",
    //  font:"",
  });
  const [chatBubbleData, setChatBubbleData] = useState({
    bubbleColour: "#59B3C6",
    //  iconBubble:"",
    //  primaryColour:"",
    //  placeholderText:"",
  });

  const [boxShape, setBoxShape] = useState({ id: 1, name: "Rectangle" });
  const [colorMode, setColorMode] = useState({ id: 1, name: "Dark Mode" });
  const [fontStyle, setFontStyle] = useState({ id: 1, name: "Inter" });
  const [primaryColour, setPrimaryColour] = useState("#59B3C6");
  const [textColour, setTextColour] = useState("#000000");
  const [placeholderText, setPlaceholderText] = useState(
    "Start Typing Here..."
  );
  const [chatMode, setChatMode] = useState({ id: 2, name: "Close" });
  const [fButtonSelection, setFButtonSelection] = useState({ id: 1, name: "None" });
  const [sButtonSelection, setSButtonSelection] = useState({ id: 1, name: "None" });
  const [mobileView, setMobileView] = useState(false);
  const [displayBubbleColor, setDisplayBubbleColor] = useState(false);
  const [displayPrimaryColor, setDisplayPrimaryColor] = useState(false);
  const [displayTextColor, setDisplayTextColor] = useState(false);

  const [greetingMsg, setGreetingMsg] = useState("");
  const [promptNumber, setPromptNumber] = useState("");
  const [promptOne, setPromptOne] = useState("");
  const [promptTwo, setPromptTwo] = useState("");
  const [open, setOpen] = useState(false);
  const [promptThree, setPromptThree] = useState("");
  const [promptFour, setPromptFour] = useState("");
  const [promptFive, setPromptFive] = useState("");
  const [TnC, setTnC] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [info, setInfo] = useState("");
  const [linkContent, setLinkContent] = useState("");
  const [enabled, setEnabled] = useState(designData?.type?.length > 0 && designData?.type === "chatBot" ? false : true)
  // const [image, setImage] = useState(null);
  const [preview, setPreview] = useState('');
  const [cropModal, setCropModal] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [croppedImage, setCroppedImage] = useState(null)
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [showPopup, setShowPopup] = useState(false);
  const [imageSrc, setImageSrc] = useState('');


  const handleMouseEnter = (src) => {
    setImageSrc(src);
    setShowPopup(true);
  };

  const handleMouseLeave = () => {
    setShowPopup(false);
  };


  useEffect(() => {
    let tempUrl = `${window.location.href}`;
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    const stagCode = `<script src='https://web-stag.askzoi.com/zap-chatbot/chatscript.js?version=2.13' data-client-id="${storedUserData?.data?.client_id}"></script>`;
    const devCode = `<script src='https://web.askzoi.com/zap-chatbot/chatscript.js?version=2.13' data-client-id="${storedUserData?.data?.client_id}"></script>`;
    const prodCode = `<script src='https://script.askzoi.ai/chatscript.js?version=2.13' data-client-id="${storedUserData?.data?.client_id}"></script>`;

    if (tempUrl.search("localhost") > 0) {
      setEmbeddCode(stagCode);
    } else if (tempUrl.search("dev.askzoi.com") > 0) {
      setEmbeddCode(devCode);
    } else if (tempUrl.search("sia.technochimes.com") > 0) {
      setEmbeddCode(stagCode);
    } else if (tempUrl.search("sia.salespanda.com") > 0) {
      setEmbeddCode(prodCode);
    } else {
      setEmbeddCode(devCode);
    }
  }, []);

  useEffect(() => {
    if (designData !== undefined && Object.keys(designData)?.length > 0) {
      setPrimaryColour(designData?.primary_color);
      setTextColour(designData?.text_color);
      setBoxShape(designData?.data?.ama_box_shape);
      setFontStyle(
        designData?.data?.font !== undefined
          ? designData?.data?.font
          : { id: 1, name: "Inter" }
      );
      setColorMode(designData?.color_mode);
      setFButtonSelection(designData?.button_first);
      setSButtonSelection(designData?.button_second);
      setPlaceholderText(designData?.placeholder_text);
      setChatMode(designData?.data?.chatshow);
      setCtaLink(designData?.cta_link);
      setChatBubbleData({ bubbleColour: designData?.data?.bubble_color });
      setChatBarData({
        //  section:false,
        sectionColour: designData?.data?.section_bg_color,
        sectionHeight: designData?.data?.section_height,
        backgroundColour: designData?.data?.ama_bg_color,
        borderColour: designData?.data?.border_color,
        width: designData?.data?.ama_width,
        //  colorMode:"",
        //  primaryColour:"",
        //  placeholderText:"",
        //  boxShape:"",
        //  font:"",
      });
      setSection(designData?.data?.section);
      setSelectedOption(designData?.type);
    }
  }, [designData]);

  const handleInputChatBarChange = (e) => {
    const { name, value } = e.target;
    setChatBarData({
      ...chatBarData,
      [name]: value,
    });
  };
  const handleInputChatBubbleChange = (color) => {
    // const { name, value } = e.target;
    setChatBubbleData({
      ...chatBubbleData,
      bubbleColour: color?.hex,
    });
  };

  const handleCheckboxChange = (option) => {
    setSelectedOption(option);
    setChatBubbleTabName("Chat Bubble");
    setTabName("Chat Bar");
  };

  const handleClipboard = () => {
    navigator.clipboard.writeText(embeddCode);
    Toast(`Copied to Clipboard`, "S");
    Mixpanel.track("Copied the embed code");
  };

  const handleSaveChanges = () => {
    const payload = {
      type: selectedOption,
      color_mode: colorMode,
      button_first: fButtonSelection,
      button_second: sButtonSelection,
      cta_link:ctaLink,
      default_calendar: selectedData?.default,
      bg_primary_color: `cb-bg-[${primaryColour}]`,
      text_color: textColour,
      primary_color: primaryColour,
      text_primary_color: `cb-text-[${primaryColour}]`,
      placeholder_text: placeholderText,
      theme_data: {
        chatBase: colorMode?.name === "Dark Mode" ? "cb-bg-[#262626]" : "",
        chatColorBase1:
          colorMode?.name === "Dark Mode" ? "cb-bg-[#000000]" : "",
        chatColorBase2:
          colorMode?.name === "Dark Mode" ? "cb-bg-[#59B3C6]" : "",
        chatColorText1:
          colorMode?.name === "Dark Mode" ? "cb-text-[#ffffff]" : "",
        chatColorText2:
          colorMode?.name === "Dark Mode" ? "cb-text-[#59B3C6]" : "",
        chatInputBase: colorMode?.name === "Dark Mode" ? "cb-bg-[#353535]" : "",
        chatInputText:
          colorMode?.name === "Dark Mode" ? "cb-text-[#ffffff]" : "",
        chatColorBorder1: colorMode?.name === "Dark Mode" ? "#000000" : "",
        chatColorBorder2:
          colorMode?.name === "Dark Mode" ? "after:cb-border-[#000000]" : "",
        chatColorTextLight1:
          colorMode?.name === "Dark Mode" ? "cb-text-[#ffffff]" : "",
      },
      data: {
        font: fontStyle,
        chatshow: chatMode,
        bubble_color: chatBubbleData?.bubbleColour,
        icon_bubble: "",
        section: section,
        section_bg_color: chatBarData?.sectionColour,
        border_color: chatBarData?.borderColour,
        ama_width: chatBarData?.width,
        ama_bg_color: chatBarData?.backgroundColour,
        section_height: chatBarData?.sectionHeight,
        ama_box_shape: boxShape,
      },
    };
    if (greetingMsg == "") {
      Toast("Greeting message should not be empty", "E");
    } else if(promptOne == "" || promptTwo == "" || promptThree == ""){
      Toast("Prompt Should not be empty", "E");
    }else{
      if (greeting_data.details.length === 0) {
        dispatch(addSuggestion(props.authToken, promptOne, promptTwo, promptThree));
      }else{
        if(greeting_data.details[0].message !== promptOne || greeting_data.details[1].message !== promptTwo || greeting_data.details[2].message !== promptThree){
          Mixpanel.track("Edited the initial prompts.");
        }
        let data = [...greeting_data.details] 
        data.map((obj, o_index) => {
          if (o_index === 0) {
            obj.message = promptOne
          } else if (o_index === 1) {
            obj.message = promptTwo
          } else if (o_index === 2) {
            obj.message = promptThree
          }else if (o_index === 3) {
            obj.message = promptFour
          }else if (o_index === 4) {
            obj.message = promptFive
          }
          return obj;
        })
        dispatch(updateSuggestion(props.authToken, data));
      }
      const payloadDisc = {
        term_link: TnC,
        privacy_policy_link: privacyPolicy,
        info: info
      }
        dispatch(addDisclamer(props.authToken, payloadDisc))
          Mixpanel.track("Edited the Disclaimer");     
          if(greeting_data.message !== greetingMsg){
            Mixpanel.track("Edited the greeting message.");
          }
          dispatch(addGreetingMessage(props.authToken, greetingMsg))
          dispatch(chatDesignData(props.authToken, payload));
          if (designData?.primary_color !== primaryColour) {
            Mixpanel.track("Edited the chatbot's primary color");
          }
          if (designData?.data?.font !== fontStyle) {
            Mixpanel.track("Edited the font in Design.");
          }
    }
    }; 

  // const handleSubmit = () => {

  //   if (greetingMsg !== "") {
  //     dispatch(addGreetingMessage(props.authToken, greetingMsg))
  //     if(greeting_data.message !== greetingMsg){
  //       Mixpanel.track("Edited the greeting message.");
  //     }
  //   } else {
  //       Toast("Greeting message should not be empty", "E");
  //   }

  //   if (greeting_data.details.length === 0) {
  //     if (promptOne !== "" && promptTwo !== "" && promptThree !== "") {
  //       dispatch(addSuggestion(props.authToken, promptOne, promptTwo, promptThree));
  //     } else {
  //       Toast("Prompt Should not be empty", "E");
  //     }
  //   } else {
  //     if (promptOne !== "" && promptTwo !== "" && promptThree !== "") {
  //       if(greeting_data.details[0].message !== promptOne || greeting_data.details[1].message !== promptTwo || greeting_data.details[2].message !== promptThree){
  //         Mixpanel.track("Edited the initial prompts.");
  //       }
  //       let data = [...greeting_data.details] 
  //       data.map((obj, o_index) => {
  //         if (o_index === 0) {
  //           obj.message = promptOne
  //         } else if (o_index === 1) {
  //           obj.message = promptTwo
  //         } else {
  //           obj.message = promptThree
  //         }
  //         return obj;
  //       })
  //       dispatch(updateSuggestion(props.authToken, data));
  //     } else {
  //       Toast("Prompt Should not be empty", "E");
  //     }
  //   }

  //   const payload = {
  //     term_link: TnC,
  //     privacy_policy_link: privacyPolicy,
  //     info: info
  //   }
  //     dispatch(addDisclamer(props.authToken, payload))
  //       Mixpanel.track("Edited the Disclaimer");     
  // }
  

  useEffect(() => {
    if (Object.keys(greeting_data) && Object.keys(greeting_data)?.length) {
      setGreetingMsg(greeting_data.message);
      setTnC(greeting_data?.disclaimer?.term_link)
      setPrivacyPolicy(greeting_data?.disclaimer?.privacy_policy_link)
      setInfo(greeting_data?.disclaimer?.info)
      if (greeting_data?.details?.length > 0) {
        setPromptOne(greeting_data.details[0]?.message || '');
        setPromptTwo(greeting_data.details[1]?.message || '');
        setPromptThree(greeting_data.details[2]?.message || '');
        setPromptFour(greeting_data.details[3]?.message || '');
        setPromptFive(greeting_data.details[4]?.message || '');
      } else {
        setPromptOne("");
        setPromptTwo("");
        setPromptThree("");
        setPromptFour("")
        setPromptFive("")
      }
    } else {
      setGreetingMsg("");
      setPromptOne("");
      setPromptTwo("");
      setPromptThree("");
      setPromptFour("")
      setPromptFive("")
    }
  }, [greeting_data])


  const tabs = [
    { name: "Chat Bar", href: "#", current: true },
    { name: "Bot Design", href: "#", current: false },
  ];
  const bubbleTabs = [
    { name: "Chat Bubble", href: "#", current: true },
    { name: "Bot Design", href: "#", current: false },
    { name: "Text Customisation", href: "#", current: false },
    { name: "CTA Buttons", href: "#", current: false },
  ];
  const amaTabs = [
    { name: "Bot Design", href: "#", current: true },
    { name: "CTA Buttons", href: "#", current: false },
    { name: "Text Customisation", href: "#", current: false },
  ];
  

  useEffect(() => {
    dispatch(fetchChatDesignData(props.authToken));
    dispatch(fetchDesignScreenshot(props.authToken));
    dispatch(greetingMessage(props.authToken));
    dispatch(fetchSelectedCalendar(props.authToken));
  }, []);

  const handleToggle = (e) =>{
    if(e){
      setSelectedOption("AMA")
      setChatBubbleTabName("Bot Design")
    }else{
      setSelectedOption("chatBot")
      setChatBubbleTabName("Chat Bubble")
    }
    setEnabled(e)
  }


  const sAMA =[
    "How does Zoi analyze website content to generate custom responses?",
    "What methods does Zoi use to tailor conversations based on visitor data?",
    "Can Zoi integrate with CRM systems for effective sales follow-up?"
]

const handleImageChange = (e) => {
  const selectedImage = e.target.files[0];
  if (!selectedImage) return;

  // setImage(selectedImage);

  const reader = new FileReader();
  reader.onloadend = () => {
    setPreview(reader.result);
  };
  reader.readAsDataURL(selectedImage);
};


const onCropComplete = (croppedArea, croppedAreaPixels) => {
  setCroppedAreaPixels(croppedAreaPixels)
}

const showCroppedImage = async () => {
  try {
    const croppedImage = await getCroppedImg(
      preview,
      croppedAreaPixels,
      // rotation
    )
    console.log('donee', { croppedImage })
    fetch(croppedImage)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => {
          const base64data = reader.result
          const size = blob.size
          const type = blob.type
          const name = blob.name
          const fileData = {
            name:"Carousel",
            type:blob.type,
            size:blob.size
          }
          dispatch(carouselImageSubmit(props.authToken,promptNumber,base64data,fileData));     
          setCropModal(false);     
          setPreview(null)
          setPromptNumber("")
          // Now you can use base64data for uploading
        }
      })
    // setCroppedImage(croppedImage)
  } catch (e) {
    console.error(e)
  }
}

const onClose = () => {
  setCroppedImage(null)
}









  return (
    <>
      {isLoading && <Loading />}
      {/* Heading with button */}
      <div className="flex justify-between mb-2 border-b border-gray-200 pb-[0.5rem]">
        <div className="text-lg leading-7 font-[500] my-auto">Design</div>
        <div className="flex">
          <button
            onClick={() => {
              handleSaveChanges();
              // handleSubmit();
            }}
            type="button"
            className="mr-4 inline-flex border border-gray-300 items-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm"
          >
            Save Changes
          </button>
          {/* <button
            // onClick={()=>{setOpen(true)}}
            type="button"
            className="inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 "
          >
            <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" />
            Test ChatAI
          </button> */}
        </div>
      </div>
      {/* Container */}
      <div className="grid grid-cols-11">
        {/* Left Screen */}
        <div className="col-span-5 max-sm:order-last max-sm:col-span-12 ">
          {/* Checkbox */}
          {/* <div className="rounded-[8px] pt-4 pb-3 px-4 bg-white mb-4">
            <div className="flex justify-between">
              <div className="flex flex-col items-center relative">
                {selectedOption === "chatBot" ? (
                  <img src={chatBubbleSvg} className="relative max-sm:w-[75%]" />
                ) : (
                  <img src={chatBubbleUnSvg} className="relative max-sm:w-[75%]" />
                )}
                <input
                  name="chatBot"
                  type="checkbox"
                  className="absolute max-sm:left-[15%] left-0 m-2 h-4 w-4 rounded border-gray-300 text-[#49BCD2] focus:ring-[#49BCD2]"
                  checked={selectedOption === "chatBot"}
                  onChange={() => handleCheckboxChange("chatBot")}
                />
                <div className="m-auto max-sm:text-[10px]">Chat Bot</div>
              </div>
              <div className="flex flex-col items-center relative">
                {selectedOption === "chatBar" ? (
                  <img src={chatBarSvg} className="relative max-sm:w-[75%]" />
                ) : (
                  <img src={chatBarUnSvg} className="relative max-sm:w-[75%]" />
                )}
                <input
                  name="chatBar"
                  type="checkbox"
                  className="absolute max-sm:left-[15%] left-0 m-2 h-4 w-4 rounded border-gray-300 text-[#49BCD2] focus:ring-[#49BCD2]"
                  checked={selectedOption === "chatBar"}
                  onChange={() => handleCheckboxChange("chatBar")}
                />
                <div className="m-auto max-sm:text-[10px]">Chat Bar</div>
              </div>
            </div>
          </div> */}
          {/* Tabs */}
          {/* Toggle For AMA And chatbot */}
          <div className="mb-4 max-sm:mt-12 flex mx-auto mt-2"><Combobox as="div" className={"w-full mx-auto my-auto flex items-center justify-between h-full"}>
                  <Combobox.Label className={`flex ml-auto text-sm max-sm:mr-auto sm:mr-[5.3rem]  leading-6 ${selectedOption === "chatBot" ? "text-gray-900 underline font-[600]":"text-gray-500"} `}>Chat Bot</Combobox.Label>
                  <Switch
      checked={enabled}
      onChange={handleToggle}
      className="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-[#F3F4F6] focus:ring-offset-2"
    >
      <span className="sr-only">Use setting</span>
      <span aria-hidden="true" className="pointer-events-none absolute h-full w-full rounded-md bg-white" />
      <span
        aria-hidden="true"
        className={classNames(
          enabled ? 'bg-gray-200' : 'bg-gray-200',
          'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out'
        )}
      />
      <span
        aria-hidden="true"
        className={classNames(
          enabled ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out'
        )}
      />
                  </Switch>
                  <Combobox.Label className={`flex ml-auto text-sm max-sm:mr-auto  sm:mr-[5.3rem] leading-6 ${selectedOption === "AMA" ? "text-gray-900 underline font-[600]":"text-gray-500"}`}>AMA Bar</Combobox.Label>
                  </Combobox>
          </div>
          {/* Toggle For AMA And chatbot */}
          {(selectedOption === "chatBot" || selectedOption === "AMA")  && (
            <div className="rounded-[8px] px-4 pb-4 bg-white max-sm:h-[25vh] listing max-sm:overflow-y-auto">
              <Tab
                tabs={selectedOption !== "chatBot" ? amaTabs:bubbleTabs}
                setTabName={setChatBubbleTabName}
                tabName={chatBubbleTabName}
              />
              {chatBubbleTabName === "Chat Bubble" && (
                <div className="bg-white rounded-md px-4 overflow-y-auto h-[54vh] listing">
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="chatOpen"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Chat Open or Close
                    </label>
                    <SimpleSelect
                      people={chatType}
                      selected={chatMode}
                      setSelected={setChatMode}
                    />
                  </div>
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="bubbleColour"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Bubble Colour
                    </label>
                    <div className="mt-2">
                      <div
                        className="border-solid border-[1px] border-black bg-black inline-block cursor-pointer"
                        onClick={() => {
                          setDisplayBubbleColor(!displayBubbleColor);
                        }}
                      >
                        <div
                          className={`w-11 h-4 `}
                          style={{
                            backgroundColor: chatBubbleData?.bubbleColour,
                          }}
                        />
                      </div>
                      {displayBubbleColor ? (
                        <div className="absolute z-20">
                          <div
                            className="fixed inset-0"
                            onClick={() => {
                              setDisplayBubbleColor(!displayBubbleColor);
                            }}
                          />
                          <ChromePicker
                            color={chatBubbleData?.bubbleColour}
                            onChange={handleInputChatBubbleChange}
                          />
                        </div>
                      ) : null}
                    </div>
                    {/* <input
                      type="color"
                      name="bubbleColour"
                      id="bubbleColour"
                      className="block w-[15%] border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder=""
                      onChange={handleInputChatBubbleChange}
                      value={chatBubbleData?.bubbleColour}
                    /> */}
                  </div>
                  {/* <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Icon Bubble
                    </label>
                    <input
                      type="text"
                      name="borderColour"
                      id="borderColor"
                      className="block w-[15%] border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder=""
                      onChange={handleInputChatBubbleChange}
                    />
                  </div> */}
                </div>
              )}
              {chatBubbleTabName === "Bot Design" && (
                <div className="bg-white rounded-md px-4 overflow-y-auto h-[54vh] listing">
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="colorMode"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Color Mode
                    </label>
                    {/* <input
                    type="text"
                    name="name"
                    id="name"
                    className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                    placeholder=""
                  /> */}
                    <SimpleSelect
                      people={colorTypes}
                      selected={colorMode}
                      setSelected={setColorMode}
                    />
                  </div>
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="primaryColour"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Primary Colour
                    </label>
                    <div className="mt-2">
                      <div
                        className="border-solid border-[1px] border-black bg-black inline-block cursor-pointer"
                        onClick={() => {
                          setDisplayPrimaryColor(!displayPrimaryColor);
                        }}
                      >
                        <div
                          className={`w-11 h-4 `}
                          style={{ backgroundColor: primaryColour }}
                        />
                      </div>
                      {displayPrimaryColor ? (
                        <div className="absolute z-20">
                          <div
                            className="fixed inset-0"
                            onClick={() => {
                              setDisplayPrimaryColor(!displayPrimaryColor);
                            }}
                          />
                          <ChromePicker
                            color={primaryColour}
                            onChange={(color) => {
                              setPrimaryColour(color.hex);
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                    {/* <input
                      type="color"
                      name="primaryColour"
                      id="primaryColour"
                      className="block w-[15%] border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder=""
                      onChange={(e) => {
                        setPrimaryColour(e.target.value);
                      }}
                      value={primaryColour}
                    /> */}
                  </div>
                  {selectedOption !== "AMA" && <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="textColour"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Text Colour
                    </label>
                    <div className="mt-2">
                      <div
                        className="border-solid border-[1px] border-black bg-black inline-block cursor-pointer"
                        onClick={() => {
                          setDisplayTextColor(!displayTextColor);
                        }}
                      >
                        <div
                          className={`w-11 h-4 `}
                          style={{ backgroundColor: textColour }}
                        />
                      </div>
                      {displayTextColor ? (
                        <div className="absolute z-20">
                          <div
                            className="fixed inset-0"
                            onClick={() => {
                              setDisplayTextColor(!displayTextColor);
                            }}
                          />
                          <ChromePicker
                            color={textColour}
                            onChange={(color) => {
                              setTextColour(color.hex);
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                    {/* <input
                      type="color"
                      name="primaryColour"
                      id="primaryColour"
                      className="block w-[15%] border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder=""
                      onChange={(e) => {
                        setPrimaryColour(e.target.value);
                      }}
                      value={primaryColour}
                    /> */}
                  </div>}
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="font"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Font
                    </label>
                    <SimpleSelect
                      people={fontTypes}
                      selected={fontStyle}
                      setSelected={setFontStyle}
                    />
                  </div>
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="placeholderText"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Placeholder text
                    </label>
                    <input
                      type="text"
                      name="placeholderText"
                      id="placeholderText"
                      className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter"
                      onChange={(e) => {
                        setPlaceholderText(e.target.value);
                      }}
                      value={placeholderText}
                    />
                  </div>
                </div>
              )}
              {chatBubbleTabName === "Text Customisation" && (
                <div className="bg-white rounded-md px-4 overflow-y-auto h-[54vh] listing">
                  {selectedOption !== "AMA" &&<div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="placeholderText"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Enter Greeting Message
                    </label>
                    <input
                      type="text"
                      name="placeholderText"
                      id="placeholderText"
                      className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Greeting"
                      value={greetingMsg}
                      onChange={(e)=>setGreetingMsg(e.target.value)}
                    />
                  </div>}
                  <div className="flex">
                  {greeting_data.details[0]?.image && (
          <img src={greeting_data.details[0]?.image} onMouseEnter={() => {handleMouseEnter(greeting_data.details[0]?.image);console.log("hi")}}
          onMouseLeave={()=>{handleMouseLeave();console.log("by")}} className="my-auto mr-2 rounded-md cursor-pointer" alt="Preview" style={{ maxWidth: '100%', maxHeight: '50px' }} />
      )}
                  <div className="rounded-md mb-2 px-3 mt-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Prompt 1
                    </label>
                    <div className="flex">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                      value={promptOne}
                      onChange={(e)=>{setPromptOne(e.target.value)}}
                    />
                    {greeting_data.details[0].message?.length > 0 && selectedOption == "AMA" && <RiImageAddLine onClick={()=>{setCropModal(true);setPromptNumber("prompt_1")}}  className="my-auto text-xl cursor-pointer"/>}
                    </div>
                  </div>
                  </div>
                  <div className="flex">
                  {greeting_data.details[1]?.image && (
          <img src={greeting_data.details[1]?.image} onMouseEnter={() => {handleMouseEnter(greeting_data.details[1]?.image);}}
          onMouseLeave={()=>{handleMouseLeave();}} className="my-auto mr-2 rounded-md cursor-pointer" alt="Preview" style={{ maxWidth: '100%', maxHeight: '50px' }} />
      )}
                  <div className="rounded-md mb-2 px-3 mt-3 pb-1.5  pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Prompt 2
                    </label>
                    <div className="flex">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                      value={promptTwo}
                      onChange={(e)=>{setPromptTwo(e.target.value)}}
                    />
                    {greeting_data.details[1].message?.length > 0 && selectedOption == "AMA" && <RiImageAddLine onClick={()=>{setCropModal(true);setPromptNumber("prompt_2")}}  className="my-auto text-xl cursor-pointer"/>}
                    </div>
                  </div>
                  </div>
                  <div className="flex">
                  {greeting_data.details[2]?.image && (
          <img src={greeting_data.details[2]?.image} onMouseEnter={() => {handleMouseEnter(greeting_data.details[2]?.image);}}
          onMouseLeave={()=>{handleMouseLeave();}} className="my-auto mr-2 rounded-md cursor-pointer" alt="Preview" style={{ maxWidth: '100%', maxHeight: '50px' }} />
      )}
                  <div className="rounded-md  px-3 mt-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Prompt 3
                    </label>
                    <div className="flex"> 
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                      value={promptThree}
                      onChange={(e)=>{setPromptThree(e.target.value)}}
                    />
                    {greeting_data.details[2].message?.length > 0 && selectedOption == "AMA" &&<RiImageAddLine onClick={()=>{setCropModal(true);setPromptNumber("prompt_3")}}  className="my-auto text-xl cursor-pointer"/>}
                    </div>
                  </div>
                  </div>
                  <div className="flex">
                  {greeting_data.details[3]?.image && (
          <img src={greeting_data.details[3]?.image} onMouseEnter={() => {handleMouseEnter(greeting_data.details[3]?.image);}}
          onMouseLeave={()=>{handleMouseLeave();}} className="my-auto mr-2 rounded-md cursor-pointer" alt="Preview" style={{ maxWidth: '100%', maxHeight: '50px' }} />
      )}
                  <div className="rounded-md  px-3 mt-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Prompt 4
                    </label>
                    <div className="flex"> 
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                      value={promptFour}
                      onChange={(e)=>{setPromptFour(e.target.value)}}
                    />
                    {greeting_data.details[3]?.message?.length > 0 && selectedOption == "AMA" &&<RiImageAddLine onClick={()=>{setCropModal(true);setPromptNumber("prompt_4")}}  className="my-auto text-xl cursor-pointer"/>}
                    </div>
                  </div>
                  </div>
                  <div className="flex">
                  {greeting_data.details[4]?.image && (
          <img src={greeting_data.details[4]?.image} onMouseEnter={() => {handleMouseEnter(greeting_data.details[4]?.image);}}
          onMouseLeave={()=>{handleMouseLeave();}} className="my-auto mr-2 rounded-md cursor-pointer" alt="Preview" style={{ maxWidth: '100%', maxHeight: '50px' }} />
      )}
                  <div className="rounded-md  px-3 mt-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Prompt 5
                    </label>
                    <div className="flex"> 
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                      value={promptFive}
                      onChange={(e)=>{setPromptFive(e.target.value)}}
                    />
                    {greeting_data.details[4]?.message?.length > 0 && selectedOption == "AMA" &&<RiImageAddLine onClick={()=>{setCropModal(true);setPromptNumber("prompt_5")}}  className="my-auto text-xl cursor-pointer"/>}
                    </div>
                  </div>
                  </div>
                  {selectedOption !== "AMA" &&<div className="rounded-md mb-2 px-3 mt-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              TnC
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Add a hyperlink for TnC"
              value={TnC}
              onChange={(e)=>{setTnC(e.target.value)}}
            />
          </div>}
          {selectedOption !== "AMA" &&<div className="rounded-md mb-2 px-3 pb-1.5 pt-2.5 mt-3 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              Privacy Policy
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Add a hyperlink for Privacy Policy"
              value={privacyPolicy}
              onChange={(e)=>{setPrivacyPolicy(e.target.value)}}
            />
          </div>}
          {selectedOption !== "AMA" &&<div className="rounded-md mb-2 px-3 pb-1.5 pt-2.5 mt-3 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              <HiOutlineInformationCircle className="text-gray-900 text-[1rem] my-auto"></HiOutlineInformationCircle>
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Add a text"
              value={info}
              onChange={(e)=>{setInfo(e.target.value)}}
            />
          </div>}
                </div>
              )}
              {chatBubbleTabName === "CTA Buttons" && (
                <div className="bg-white rounded-md px-4 overflow-y-auto h-[54vh] listing">
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="chatOpen"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Button 1
                    </label>
                    <SimpleSelect
                      people={firstButton}
                      selected={fButtonSelection}
                      setSelected={setFButtonSelection}
                      sData={sButtonSelection}
                      disableCalendar={selectedData?.default?.length === 0 && true}
                    />
                  </div>
                  { fButtonSelection?.name === "Link" &&  <div className="rounded-md mb-2 px-3 mt-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Enter Link
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                      value={ctaLink}
                      onChange={(e)=>{setCtaLink(e.target.value)}}
                    />
                  </div>}
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="chatOpen"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Button 2
                    </label>
                    <SimpleSelect
                      people={secondButton}
                      selected={sButtonSelection}
                      setSelected={setSButtonSelection}
                      sData={fButtonSelection}
                      disableCalendar={selectedData?.default?.length === 0 && true}
                    />
                  </div>
                  { sButtonSelection?.name === "Link" &&  <div className="rounded-md mb-2 px-3 mt-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Enter Link
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                      value={ctaLink}
                      onChange={(e)=>{setCtaLink(e.target.value)}}
                    />
                  </div>}
                  {selectedData?.default?.length === 0 && <div className="text-red-500 mt-2 ml-2" >*Please set up calendar in user setting to select calendar</div>}
                  
                  {/* <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Icon Bubble
                    </label>
                    <input
                      type="text"
                      name="borderColour"
                      id="borderColor"
                      className="block w-[15%] border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder=""
                      onChange={handleInputChatBubbleChange}
                    />
                  </div> */}
                </div>
              )}
            </div>
          )}
          {selectedOption === "chatBar" && (
            <div className="rounded-[8px] px-4 pb-4 bg-white max-sm:h-[25vh] listing max-sm:overflow-y-auto">
              <Tab tabs={tabs} setTabName={setTabName} tabName={tabName} />
              {tabName === "Chat Bar" && (
                <div className="bg-white rounded-md px-4 lg:overflow-y-auto lg:h-[54vh] listing">
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="section"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Section
                    </label>
                    <div className="flex justify-between">
                      <input
                        type="text"
                        name="section"
                        id="name"
                        className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                        // placeholder=""
                        value={section ? "Section On" : "Section Off"}
                        disabled
                      />
                      <Switch
                        name="section"
                        id="section"
                        checked={section}
                        onChange={setSection}
                        className={classNames(
                          section ? "bg-[var(--brand-primary)]" : "bg-gray-200",
                          "relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
                        )}
                      >
                        <span className="sr-only">Use setting</span>
                        <span
                          aria-hidden="true"
                          className={classNames(
                            section ? "translate-x-5" : "translate-x-0",
                            "pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                          )}
                        />
                      </Switch>
                    </div>
                  </div>
                  {section && (
                    <>
                      <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                        <label
                          htmlFor="sectionColor"
                          className="block text-xs font-medium text-gray-800"
                        >
                          Section Color
                        </label>
                        <input
                          type="color"
                          name="sectionColour"
                          id="sectionColor"
                          className="block w-[15%] border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                          placeholder=""
                          onChange={handleInputChatBarChange}
                          value={chatBarData?.sectionColour}
                        />
                      </div>
                      <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                        <label
                          htmlFor="sectionHeight"
                          className="block text-xs font-medium text-gray-800"
                        >
                          Section Height
                        </label>
                        <input
                          type="text"
                          name="sectionHeight"
                          id="sectionHeight"
                          className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                          placeholder="Enter"
                          value={chatBarData?.sectionHeight}
                          onChange={handleInputChatBarChange}
                        />
                      </div>
                    </>
                  )}
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="backgroundColour"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Background Colour
                    </label>
                    <input
                      type="color"
                      name="backgroundColour"
                      id="backgroundColour"
                      className="block w-[15%] border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder=""
                      onChange={handleInputChatBarChange}
                      value={chatBarData?.backgroundColour}
                    />
                  </div>
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="borderColor"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Border Color
                    </label>
                    <input
                      type="color"
                      name="borderColour"
                      id="borderColor"
                      className="block w-[15%] border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder=""
                      onChange={handleInputChatBarChange}
                      value={chatBarData?.borderColour}
                    />
                  </div>
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="width"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Width
                    </label>
                    <input
                      type="text"
                      name="width"
                      id="width"
                      className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter"
                      onChange={handleInputChatBarChange}
                      value={chatBarData.width}
                    />
                  </div>
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="boxShape"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Box Shape
                    </label>
                    <SimpleSelect
                      people={boxTypes}
                      selected={boxShape}
                      setSelected={setBoxShape}
                    />
                    {/* <input
                    type="text"
                    name="boxShape"
                    id="boxShape"
                    className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                    placeholder=""
                    onChange={handleInputChatBarChange}
                    value={chatBarData?.boxShape}
                  /> */}
                  </div>
                  {/* <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                  <label
                    htmlFor="name"
                    className="block text-xs font-medium text-gray-800"
                  >
                    Font
                  </label>
                  <input
                    type="text"
                    name="font"
                    id="font"
                    className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                    placeholder=""
                    onChange={handleInputChatBarChange}
                    value={chatBarData?.font}
                  />
                </div> */}
                </div>
              )}
              {tabName === "Bot Design" && (
                <div className="bg-white rounded-md px-4 overflow-y-auto h-[33vh] listing">
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="colorModeq"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Color Mode
                    </label>
                    {/* <input
                    type="text"
                    name="name"
                    id="name"
                    className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                    placeholder=""
                  /> */}
                    <SimpleSelect
                      people={colorTypes}
                      selected={colorMode}
                      setSelected={setColorMode}
                    />
                  </div>
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="primaryColourq"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Primary Colour
                    </label>
                    <input
                      type="color"
                      name="primaryColour"
                      id="primaryColour"
                      className="block w-[15%] border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder=""
                      onChange={(e) => {
                        setPrimaryColour(e.target.value);
                      }}
                      value={primaryColour}
                    />
                  </div>
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="fontq"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Font
                    </label>
                    {/* <input
                    type="text"
                    name="name"
                    id="name"
                    className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                    placeholder=""
                  /> */}
                    <SimpleSelect
                      people={fontTypes}
                      selected={fontStyle}
                      setSelected={setFontStyle}
                    />
                  </div>
                  <div className="rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="placeholderTextq"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Placeholder text
                    </label>
                    <input
                      type="text"
                      name="placeholderText"
                      id="placeholderText"
                      className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter"
                      onChange={(e) => {
                        setPlaceholderText(e.target.value);
                      }}
                      value={placeholderText}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        {/* Left Screen */}
        {/* Right Screen */}
        <div className="col-span-6 max-sm:order-first max-sm:col-span-12 ">
          <div className={`bg-white p-2 rounded-md mb-2 flex justify-between ${selectedOption === "chatBot" ? "w-[20%]":"w-[15%]"} max-sm:w-[30%] mx-auto`}>
            {selectedOption === "chatBot"  && <Phone
              onClick={() => setMobileView(true)}
              className={`${
                mobileView && embeddModal == false && "text-yellow-500"
              } text-lg cursor-pointer`}
            />}
            <Display
              onClick={() => setMobileView(false)}
              className={`${
                !mobileView && embeddModal == false && "text-yellow-500"
              } text-lg cursor-pointer`}
            />
            <Code
              className={`${embeddModal && "text-yellow-500"} text-lg`}
              onClick={() => {
                setEmbeddModal(true);
              }}
            />
          </div>
          {/* Chatbot preview */}
          {selectedOption === "chatBot" && <div className={`${mobileView && "px-28 max-sm:px-16"}`}>
            {chatBubbleTabName === "Bot Design" || tabName === "Bot Design" || chatBubbleTabName === "Text Customisation" || chatBubbleTabName === "CTA Buttons" ? (
              <div
                className={`${
                  colorMode?.name === "Dark Mode"
                    ? `bg-[#262626]`
                    : "bg-[#EFEFEF]"
                }  ${
                  mobileView
                    ? "w-[100%] px-[10px] pt-[20px] pb-[15px] max-sm:w-[80%] max-sm:h-[32vh]"
                    : "w-[90%] px-[20px] pt-[25px] pb-[20px] ml-6 max-sm:p-[15px] max-sm:w-[70%] max-sm:h-[30vh]"
                } chatBot  h-[68vh] flex flex-col rounded-[40px] max-sm:rounded-[15px] shadow-xl relative max-sm:m-auto`}
              >
                <div className="overflow-y-auto messageContainer mb-[1rem]">
                  {/* ZAP bot Welcome Message */}

                  <>
                    <div className="flex zapBot">
                      <div
                        className={`${
                          colorMode?.name === "Dark Mode"
                            ? `bg-[#000000]`
                            : "bg-[#FFFFFF]"
                        } ${
                          mobileView ? "w-[80%]" : "w-[70%]"
                        } p-[20px] mb-[0.25rem] text-left max-sm:ml-[10px] relative ml-[25px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] max-sm:p-[10px]`}
                      >
                        <span
                          className="triangleBorder top-[0] left-[-5%] max-sm:left-[-14px] w-0 h-0 absolute z-[9] border-t-[22px] border-x-[20px] border-x-transparent border-solid"
                          style={{
                            borderTopColor:
                              colorMode?.name === "Dark Mode"
                                ? "#000000"
                                : "#ffffff",
                          }}
                        ></span>
                        <div
                          style={{
                            color: primaryColour,
                            fontFamily: fontStyle?.name,
                          }}
                          className={`${
                            primaryColour?.length > 0 ? "" : "text-[#59B3C6]"
                          }  font-[600] ${
                            mobileView ? "text-[12px] " : "text-[14px]"
                          } mb-2 max-sm:mb-0 max-sm:text-[10px] max-sm:pl-[5px]`}
                        >
                          SIA Says
                        </div>
                        <div
                          style={{ fontFamily: fontStyle?.name }}
                          className={`${
                            colorMode?.name === "Dark Mode"
                              ? `text-[#ffffff]`
                              : "text-[#000000]"
                          }  font-[700] ${
                            mobileView
                              ? "text-[15px] leading-[15px]"
                              : "text-[18px] leading-[21px]"
                          }  mb-2 max-sm:mb-0 max-sm:text-[12px] max-sm:leading-[15px]`}
                        >
                          {greetingMsg ? greetingMsg : "👋 Hello! Ask me anything." }
                        </div>
                      </div>
                    </div>
                    <div className="w-[85%] mb-[1.25rem]">
                      <div
                        style={{ fontFamily: fontStyle?.name }}
                        className={`${
                          colorMode?.name === "Dark Mode"
                            ? `text-[#ffffff]`
                            : "text-[#808080]"
                        } font-[600] ${
                          mobileView
                            ? "text-[10px] leading-[15px]"
                            : "text-[12px] leading-[21px]"
                        }  ml-8 mb-2 max-sm:ml-4 max-sm:mb-1 max-sm:text-[5px] max-sm:leading-[5px]`}
                      >
                        Start with a question or book a meeting below👇
                      </div>

                      <>
                        {greeting_data?.details[0]?.message?.length > 0 && (
                          <div
                            style={{
                              backgroundColor: primaryColour,
                              color: textColour,
                            }}
                            className={`${
                              primaryColour?.length > 0 ? "" : "bg-[#59B3C6]"
                            } py-[0.5rem] px-[1rem] max-sm:py-[3px] max-sm:px-2 rounded-[20px] max-sm:rounded-[10px] ml-6 max-sm:ml-4 mb-2 max-sm:mb-1 cursor-pointer inline-block`}
                          >
                            <div
                              style={{ fontFamily: fontStyle?.name }}
                              className={`font-[500] ${
                                mobileView
                                  ? "text-[11px] leading-[15px]"
                                  : "text-[14px] leading-[21px]"
                              } max-sm:text-[8px] max-sm:leading-[10px]`}
                              // className={`font-[500] text-[11px] leading-[15px]":"text-[14px] leading-[21px]`}
                              // title={item?.message}
                            >
                              {/* {mobileView ? item?.message : item?.message?.length > 40
                              ? `${item?.message.slice(0, 40)}...`
                              : item?.message} */}
                              {promptOne ? promptOne : "Question 1"}
                            </div>
                          </div>
                        )}
                        {greeting_data?.details[1]?.message?.length > 0 && (
                          <div
                            style={{
                              backgroundColor: primaryColour,
                              color: textColour,
                            }}
                            className={`${
                              primaryColour?.length > 0 ? "" : "bg-[#59B3C6]"
                            } py-[0.5rem] px-[1rem] max-sm:py-[3px] max-sm:px-2 rounded-[20px] max-sm:rounded-[10px] ml-6 max-sm:ml-4 mb-2 max-sm:mb-1 cursor-pointer inline-block`}
                          >
                            <div
                              style={{ fontFamily: fontStyle?.name }}
                              title="How does salespanda help in insurance?"
                              className={`font-[500] ${
                                mobileView
                                  ? "text-[11px] leading-[15px]"
                                  : "text-[14px] leading-[21px]"
                              }  max-sm:text-[8px] max-sm:leading-[10px]`}
                              // className={`font-[500] text-[11px] leading-[15px]":"text-[14px] leading-[21px]`}
                              // title={item?.message}
                            >
                              {/* {mobileView ? item?.message : item?.message?.length > 40
                              ? `${item?.message.slice(0, 40)}...`
                              : item?.message} */}
                              {promptTwo ? promptTwo : "Question 2"}
                            </div>
                          </div>
                        )}
                        {greeting_data?.details[2]?.message?.length > 0 && (
                          <div
                            style={{
                              backgroundColor: primaryColour,
                              color: textColour,
                            }}
                            className={`${
                              primaryColour?.length > 0 ? "" : "bg-[#59B3C6]"
                            } py-[0.5rem] px-[1rem] max-sm:py-[3px] max-sm:px-2 rounded-[20px] max-sm:rounded-[10px] ml-6 max-sm:ml-4 mb-2 max-sm:mb-1 cursor-pointer inline-block`}
                          >
                            <div
                              style={{ fontFamily: fontStyle?.name }}
                              className={`font-[500] ${
                                mobileView
                                  ? "text-[11px] leading-[15px]"
                                  : "text-[14px] leading-[21px]"
                              } max-sm:text-[8px] max-sm:leading-[10px]`}
                              // className={`font-[500] text-[12px] leading-[15px]":"text-[14px] leading-[21px]`}
                              // title={item?.message}
                            >
                              {/* {mobileView ? item?.message : item?.message?.length > 40
                              ? `${item?.message.slice(0, 40)}...`
                              : item?.message} */}
                              {promptThree ? promptThree : "Question 3"}
                            </div>
                          </div>
                        )}
                      </>
                    </div>
                  </>

                  {/* ZAP bot Welcome Message */}
                </div>
                {/* Send Bar */}
                <div
                  className={`${mobileView ? "px-2 max-sm:px-0 " : ""} mt-auto`}
                >
                  <div className="mt-auto flex">
                  <FaBroom
              style={{ color: primaryColour }}
              title="Clean Chat"
              className={`text-[1.9rem] p-1 my-auto mr-2 w-8 h-8 px-[0.15em] py-[0.1em] rounded-full bg-white text-[#49BCD2]`}
            ></FaBroom>
                    <div className="flex mr-auto justify-center w-[90%] ">
                      <div
                        className={`flex w-full max-sm:px-[10px] py-2 px-4 max-sm:py-0 border shadow-[0px_23px_35px_-24px_rgba(0,0,0,0.1)] rounded-[20px] border-solid border-[rgba(0,0,0,0.05)] mt-auto ${
                          "bg-[#ffffff]"
                        }`}
                      >
                        <textarea
                          style={{ fontFamily: fontStyle?.name }}
                          disabled
                          className={`w-full resize-none border-0 chatInput ${
                            mobileView
                              ? "placeholder:text-[12px] max-sm:placeholder:text-[8px] "
                              : "placeholder:text-[14px] max-sm:placeholder:text-[8.5px] "
                          } h-[20px] my-auto mt-1 ${
                            "bg-[#ffffff]"
                          } ${
                            "text-[#808080]"
                          }`}
                          placeholder={
                            placeholderText?.length > 0
                              ? placeholderText
                              : "Start Typing here..."
                          }
                          rows="1"
                          maxlength="2000"
                          // value={counterValue !== undefined ? "" : question}
                          // onInput={handleTextareaResize}
                          // onChange={(e) => {
                          //   setQuestion(e.target.value);
                          // }}
                          // onKeyDown={(e) => {
                          //   if (e.key === "Enter" && question !== "" && !flag) {
                          //     e.preventDefault();
                          //     handleSubmit();
                          //     const textarea = textareaRef.current;
                          //     textarea.style.height = "auto";
                          //   }
                          // }}
                        ></textarea>
                        {
                          <div
                            className={`ml-auto my-auto pl-[10px] ${
                              "text-[#000000]"
                            } font-[700] ${
                              mobileView
                                ? "text-[12px] max-sm:text-[8px] max-sm:pl-[0px]"
                                : "text-[14px] max-sm:text-[10px] "
                            } cursor-pointer`}
                          >
                            Send
                          </div>
                        }
                      </div>
                    </div>
                    {fButtonSelection?.name === "Calendar" && <span
                      className="my-auto ml-2 cursor-pointer"
                      style={{ color: primaryColour }}
                    >
                      <LuCalendarDays className="w-[23px] h-[23px] mr-[0.3rem]" />
                    </span>}
                   {fButtonSelection?.name === "Contact" && <span
                      className="my-auto ml-2 cursor-pointer"
                      style={{ color: primaryColour }}
                    >
                      <MdOutlineSupportAgent className="w-[23px] h-[23px] mr-[0.3rem]" />
                    </span>}
                   {fButtonSelection?.name === "Link" && <span
                      className="my-auto ml-2 cursor-pointer"
                      style={{ color: primaryColour }}
                    >
                      <LuMonitorPlay className="w-[23px] h-[23px] mr-[0.3rem]" />
                    </span>}
                    {sButtonSelection?.name === "Calendar" && <span
                      className="my-auto ml-2 cursor-pointer"
                      style={{ color: primaryColour }}
                    >
                      <LuCalendarDays className="w-[23px] h-[23px] mr-[0.3rem]" />
                    </span>}
                   {sButtonSelection?.name === "Contact" && <span
                      className="my-auto ml-2 cursor-pointer"
                      style={{ color: primaryColour }}
                    >
                      <MdOutlineSupportAgent className="w-[23px] h-[23px] mr-[0.3rem]" />
                    </span>}
                    {sButtonSelection?.name === "Link" && <span
                      className="my-auto ml-2 cursor-pointer"
                      style={{ color: primaryColour }}
                    >
                      <LuMonitorPlay className="w-[23px] h-[23px] mr-[0.3rem]" />
                    </span>}
                    {/* MdOutlineSupportAgent */}
                    {/* LuMonitorPlay */}
                  </div>
                  {/* <div className="flex mt-2">
                  <div
                    className={`${
                      colorMode?.name === "Dark Mode"
                        ? "text-gray-100"
                        : "text-black"
                    } ${
                      mobileView
                        ? "text-[0.4rem] "
                        : "text-[0.6rem] "
                    }  pl-5 pr-1 leading-[1em] my-auto`}
                  >
                    The usage of this bot and information captured is subject to
                    our{" "}
                    <a
                      href="https://www.salespanda.com/terms-conditions"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${
                        mobileView
                          ? "text-[0.4rem] "
                          : "text-[0.6rem] "
                      } cursor-pointer ${
                        colorMode?.name === "Dark Mode"
                          ? "text-gray-100"
                          : "text-black"
                      }`}
                    >
                      TnC
                    </a>{" "}
                    & 
                    <a
                      className={`${
                        mobileView
                          ? "text-[0.4rem] "
                          : "text-[0.6rem] "
                      } cursor-pointer ${
                        colorMode?.name === "Dark Mode"
                          ? "text-gray-100"
                          : "text-black"
                      }`}
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.salespanda.com/privacy-policy"
                    >
                      Privacy Policy
                    </a>
                    .
                  </div>
                  <InformationCircleIcon
                    title="The answers provided by this but can be inaccurate or even alltogether wrong. On using this bot, you accept these risks. Please read our full Terms and Conditions and Privacy Policy for details."
                    className={`${
                      colorMode?.name === "Dark Mode"
                        ? "text-gray-100"
                        : "text-black"
                    } h-[10px] my-auto`}
                  ></InformationCircleIcon>
                </div> */}
                </div>
                {/* Send Bar */}
                
                <div className="flex justify-between mt-2 mx-1">
            <div  className={`text-[0.6rem]  pl-3 pr-1 leading-[1em] my-auto cursor-pointer no-underline ${
                colorMode?.name === "Dark Mode" ? "text-gray-100" : "text-black" // Apply white text if value is selected
              }`}>Powered by ZOI</div>
            <div className="flex">
            <div
              className={`text-[0.6rem]  pl-5 pr-1 leading-[1em] my-auto flex ${
                colorMode?.name === "Dark Mode" ? "text-gray-100" : "text-black" // Apply white text if value is selected
              }`}
            >
              {TnC?.length > 0 && <div
              
                className={`text-[0.6rem] cursor-pointer no-underline mr-1  ${
                  colorMode?.name === "Dark Mode" ? "text-gray-100" : "text-black" // Apply white text if value is selected
                }`}
              >
                TnC
              </div>}
              {privacyPolicy?.length > 0 && TnC?.length > 0 && <span className="mr-1">{" "}&{" "}</span>}
              {privacyPolicy?.length > 0 && 
              <div
                className={`text-[0.6rem] cursor-pointer no-underline  ${
                  colorMode?.name === "Dark Mode" ? "text-gray-100" : "text-black" // Apply white text if value is selected
                }`}
                
              >
               Privacy Policy
              </div>}
            </div>
            {info?.length > 0 && <HiOutlineInformationCircle
              title={info}
              className={`text-[1rem] my-auto cursor-pointer ${
                colorMode?.name === "Dark Mode" ? "text-gray-100" : "text-black" // Apply white text if value is selected
              }`}
            ></HiOutlineInformationCircle>}
            </div>
          </div>

              </div>
            ) : (
              <div className="pl-4 ">
                <div
                  className={`${
                    !mobileView
                      ? "h-[200px] sm:h-[300px] md:h-[450px] lg:h-full"
                      : "h-[300px] sm:h-[300px] md:h-[400px] lg:h-[400px]"
                  } overflow-y-auto relative`}
                >
                  {!mobileView ? (
                    <img
                      src={designScreenshot?.desktop_view}
                      className="w-[100%] mx-auto"
                    />
                  ) : (
                    <img
                      src={designScreenshot?.mobile_view}
                      className="w-[100%] mx-auto"
                    />
                  )}
                  <div
                    style={{ backgroundColor: chatBubbleData?.bubbleColour }}
                    className={`${
                      !mobileView
                        ? "bottom-2 w-10 h-10 sm:w-8 sm:h-8"
                        : "bottom-2 w-10 h-10  sm:w-8 sm:h-8"
                    } absolute right-4 mt-2  text-white rounded-[100%] text-center cursor-pointer py-2 flex`}
                  >
                    <BsChatLeftText className="text-black text-md mx-auto my-auto"></BsChatLeftText>
                  </div>
                </div>
                {/* <div className='w-[90%] sm:w-[35%] absolute bottom-[25%] lg:bottom-[18%] md:bottom-[22%] sm:bottom-[30%]  right-[7%] md:right-[9%] sm:right-[12%]'>
  <ChatbotResponsive/>
  </div> */}
              </div>
            )}
          </div>}
          {/* Chatbot preview */}
          {/* AMA preview */}
          {selectedOption === "AMA" && <div className={`${mobileView && "px-28 max-sm:px-16"}`}>
            {chatBubbleTabName === "Bot Design" || tabName === "Bot Design" || chatBubbleTabName === "Text Customisation" || chatBubbleTabName === "CTA Buttons" ? (
              <div
              style={{ fontFamily: fontStyle?.name, }}
                className={`${
                  colorMode?.name === "Dark Mode"
                    ? `bg-[#262626]`
                    : "bg-[#EFEFEF]"
                }  ${
                  mobileView
                    ? "w-[100%] px-[10px] pt-[20px] pb-[15px] max-sm:w-[80%] max-sm:h-[32vh]"
                    : "w-[100%] px-[20px] pt-[25px] pb-[20px] ml-6 max-sm:p-[15px] max-sm:w-[70%] max-sm:h-[30vh]"
                } chatBot  h-[60vh] flex flex-col rounded-[10px] max-sm:rounded-[15px] shadow-xl relative max-sm:m-auto`}
              >
                <div className="overflow-y-auto messageContainer mb-[1rem]">
                  {/* ZAP bot Welcome Message */}

                  <>
                  <div className="grid grid-cols-10 gap-x-2">
                    <div className="col-span-7 ">
                    <div className="zapBot">
                      <div
                        className={`${
                          mobileView ? "w-[80%]" : "w-[70%]"
                        } mb-[0.25rem] text-left max-sm:ml-[10px] relative rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] max-sm:p-[10px]`}
                      >
                        
                        <div
                          style={{ fontFamily: fontStyle?.name,color:primaryColour, }}
                          className={`  font-[700] ${
                            mobileView
                              ? "text-[15px] leading-[15px]"
                              : "text-[18px] leading-[21px]"
                          }  mb-2 max-sm:mb-0 max-sm:text-[12px] max-sm:leading-[15px]`}
                        >
                          What is Zoi?
                        </div>
                      </div>
                    </div>
                    <div style={{fontFamily: fontStyle?.name,color: colorMode?.name ===
                                            "Dark Mode"
                                            ? `white`
                                            : "black", }} className=" text-[8px]">
                    Zoi is a conversational AI platform designed by Bizight Solutions Pvt. Ltd. to convert website visitors into leads through custom responses generated by analyzing website content. It can gather visitor data, tailor conversations, and collect customer intent information for sales follow-up. Zoi provides a human-like experience 24/7 for consistent engagement and lead conversions.
                    </div>
                    <div>
                    {(
                          <div className="w-[85%] mb-[1.25rem]">
                            {<div style={{fontFamily: fontStyle?.name,
                                            color: colorMode?.name ===
                                            "Dark Mode"
                                            ? `white`
                                            : "black",
                                            borderColor: colorMode?.name ===
                                            "Dark Mode"
                                            ? `gray`
                                            : "black",
                                          }} className="flex border-b-[1px] border-t-0 border-x-0 border-solid w-[95%] sm:w-[82%] my-auto">
                            <div className="my-auto"><FaList style={{color:primaryColour}} className="mr-2 mb-1 text-[8px] my-auto"/></div>
                            <div style={{fontFamily: fontStyle?.name,color:primaryColour}} className="font-[600] text-[8px]  pb-[0.5rem] mt-1 ">Related</div>
                            </div>}
                            {sAMA.map((s_item, s_index) => {
                                return (
                                  <>
                                    {s_index < 3 && (
                                      <div
                                        className={`${
                                          s_index == 2 && "relative"
                                        }`}
                                      >
                                        <div
                                          style={{
                                            fontFamily: fontStyle?.name,
                                            // backgroundColor: primaryColour,
                                            color: colorMode?.name ===
                                            "Dark Mode"
                                            ? `white`
                                            : "black",
                                            borderColor: colorMode?.name ===
                                            "Dark Mode"
                                            ? `gray`
                                            : "black",
                                          }}
                                          className={`py-[0.2rem] w-[90%] sm:w-[80%] pr-[1rem] cursor-pointer border-b-[1px] border-t-0 border-x-0 border-solid flex my-auto`}
                                        >
                                            <div className="mr-2"><CiCirclePlus className="text-[8px]" /></div>
                                          <div
                                            className={`font-[500] my-auto hover:text-[#49BCD2] ${
                                              mobileView
                                                ? "text-[8px]"
                                                : "text-[8px]"
                                            }`}
                                            // title={item}
                                          >
                                            {mobileView
                                              ? `${s_item.slice(0,40)}...`
                                              : s_item?.length > 55
                                              ? `${s_item.slice(0,45)}...`
                                              : s_item}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                );
                              })}
                          </div>
                        )}
                    </div>
                    </div>
                    <div className="col-span-3">
                    <div className="text-white text-[8px] ">
                              <div
                                style={{
                                  color: colorMode ===
                                  "Dark Mode"
                                  ? `white`
                                  : "black",
                                }}
                                className="flex flex-col "
                              >
                                <div style={{borderColor: colorMode?.name ===
                                  "Dark Mode"
                                  ? `gray`
                                  : "black",}} className="flex pb-2 border-[1px] border-solid border-x-0 border-t-0">
                                      <BiLinkAlt style={{color:primaryColour}} className="my-auto text-[8px] mr-[0.2rem]" />

                                  <div style={{fontFamily: fontStyle?.name,
                                                      // backgroundColor:
                                                      //   primaryColour,
                                                      color: primaryColour,
                                                    }} className="font-[600] text-[10px]">
                                    Resources
                                  </div>
                                </div>
                                {(
                                  <div className="flex">
                                    <div className="text-[#59B3C6] py-2 flex flex-col">
                                      {[...Array(2)].map((urlDocItem, index) => {
                                          return (
                                            <>
                                              {(
                                                <>
                                                <div
                                                 style={{
                                                      color: colorMode?.name ===
                                                      "Dark Mode"
                                                      ? `white`
                                                      : "black",
                                                      borderColor:primaryColour,
                                                    }} className="border-[1px] shadow-md  border-solid text-[2px] px-1  py-1 rounded-md mb-3 w-[95%]">
                                                      
                                                      <div className="flex flex-col">
                                                        <div className="flex justify-between">
                                                      <div className="mr-1"><img className="w-3 h-3" src={"https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.salespanda.com/what-is-sales-acceleration&size=16"}/></div>
                                                      <div style={{color:primaryColour,fontFamily: fontStyle?.name}} className="bg-[#ECFEFF] text-[5px] my-auto px-1 py-1 rounded-md">Crawled URL</div>
                                                        </div>
                                                        <div className="flex justify-between">
                                                      <div style={{fontFamily: fontStyle?.name}}
                                                    className=" font-[600] cursor-pointer text-[6px] mt-1"
                                                    
                                                  >
                                                    {"https://www.askzoi.ai/..."}
                                                  </div>
                                                  
                                                        </div>
                                                      </div>
                                                  <div style={{fontFamily: fontStyle?.name}} className={`text-[5px] ${colorMode?.name ===
                                                      "Dark Mode"
                                                      ? `text-gray-200`
                                                      : "text-black"} hover:text-[#49BCD2] cursor-pointer`}>{"Convert your website into a conversational platform in just 5 minutes with Zoi AI Copilot...."}</div>
                                                </div>
                                                  
                                                </>
                                              )}
                                            </>
                                          );
                                        })}
                                      {/* {item?.urls?.docs?.list &&
                                        item?.urls?.docs?.list?.length > 0 &&
                                        item?.urls?.docs?.list?.map((urlDocItem, index) => {
                                          return (
                                            <>
                                              {index <
                                                (moreIds.includes(item?.id)
                                                  ? 5
                                                  : 1) && (
                                                <>
                                                <div
                                                 onClick={() => {
                                                  setLinkData(item)
                                                  setLinkShow(true)
                                                  setDrawerContent("Doc")
                                                }}
                                                // onClick={(e) =>
                                                //   handleLinks(
                                                //     urlDocItem?.url
                                                //   )
                                                // }
                                                 style={{
                                                      // backgroundColor:
                                                      //   primaryColour,
                                                      color: colorMode?.name ===
                                                      "Dark Mode"
                                                      ? `white`
                                                      : "black",
                                                      borderColor:primaryColour,
                                                    }} className="border-[1px] shadow-md  border-solid leading-[17px] mr-[0.5rem] py-2 rounded-md mb-3">
                                                      
                                                      <div className="flex flex-col">
                                                        <div className="flex justify-between pr-4 ">
                                                      <div className="mr-1"><img className="w-15 h-15" src={"https://s3-zap.s3.ap-south-1.amazonaws.com/Adobe%20PDF%201-1712236067.svg"}/></div>
                                                      <div style={{color:primaryColour}} className="bg-[#ECFEFF] text-[10px] my-auto px-2 py-1 rounded-md">Document</div>
                                                        </div>
                                                        <div className="flex justify-between px-4 ">
                                                      <div
                                                    className=" font-[600] cursor-pointer text-[12px] mt-1"
                                                    title={urlDocItem?.title}
                                                  >
                                                    {urlDocItem?.type == "document"
                                                      && `${
                                                          urlDocItem?.title
                                                            ?.length > 35
                                                            ? `${urlDocItem?.title.slice(
                                                                0,
                                                                25
                                                              )}..`
                                                            : `${urlDocItem?.title},`
                                                        }`
                                                      }
                                                  </div>
                                                  <div className="bg-gray-300 rounded-full w-4 mr-3 flex h-4"><div style={{color:"black"}} className="text-[8px] mx-auto my-auto text-center ">
                                                  {item?.urls?.docs?.count}
                                                  </div>
                                                    </div>
                                                        </div>
                                                      </div>
                                                  <div className={`text-[10px] ${colorMode?.name ===
                                                      "Dark Mode"
                                                      ? `text-gray-200`
                                                      : "text-black"} hover:text-[#49BCD2] cursor-pointer px-4 `}>{urlDocItem?.description?.length > 80 ? `${urlDocItem?.description?.slice(0,120)}...`:urlDocItem?.description }</div>
                                                </div>
                                                  
                                                </>
                                              )}
                                            </>
                                          );
                                        })} */}
                                    </div>
                                  </div>
                                )}
                              </div>
                            
                      </div>
                    </div>
                  </div>
                  </>

                  {/* ZAP bot Welcome Message */}
                </div>
                {/* Send Bar */}
                <div
                  className={`${mobileView ? "px-2 max-sm:px-0 " : ""} mt-auto`}
                >
                  <div className="mt-auto flex">
                  <FaBroom
              style={{ color: primaryColour }}
              title="Clean Chat"
              className={`text-[1.9rem] ml-auto p-1 my-auto  w-5 h-5 px-[0.15em] py-[0.1em] rounded-full bg-white text-[#49BCD2]`}
            ></FaBroom>
                    <div className="flex mr-4 justify-center w-[50%] ml-4 ">
                      <div
                        className={`flex w-full max-sm:px-[10px] pb-1 px-4 max-sm:py-0 border shadow-[0px_23px_35px_-24px_rgba(0,0,0,0.1)] rounded-[20px] border-solid border-[rgba(0,0,0,0.05)] mt-auto ${
                          "bg-[#ffffff]"
                        }`}
                      >
                        <textarea
                          style={{ fontFamily: fontStyle?.name }}
                          disabled
                          className={`w-full resize-none border-0 chatInput ${
                            mobileView
                              ? "placeholder:text-[12px] max-sm:placeholder:text-[8px] "
                              : "placeholder:text-[14px] max-sm:placeholder:text-[8.5px] "
                          } my-auto mt-1 ${
                            "bg-[#ffffff]"
                          } ${
                            "text-[#808080]"
                          }`}
                          placeholder={
                            placeholderText?.length > 0
                              ? placeholderText
                              : "Start Typing here..."
                          }
                          rows="1"
                          maxlength="2000"
                        ></textarea>
                        {<AiOutlineSend style={{color: primaryColour}} className="text-[16px] my-auto pt-1" />
                          // <div
                          //   className={`pt-1 ml-auto my-auto pl-[10px] ${
                          //     "text-[#000000]"
                          //   } font-[700] ${
                          //     mobileView
                          //       ? "text-[10px] max-sm:text-[8px] max-sm:pl-[0px]"
                          //       : "text-[10px] max-sm:text-[10px] "
                          //   } cursor-pointer`}
                          // >
                          //   Sendn
                          // </div>
                        }
                      </div>
                    </div>
                    {fButtonSelection?.name === "Calendar" && <span
                      className="my-auto cursor-pointer"
                      style={{ color: primaryColour }}
                    >
                      <LuCalendarDays className="w-[18px] h-[18px] mr-[0.3rem]" />
                    </span>}
                   {fButtonSelection?.name === "Contact" && <span
                      className="my-auto cursor-pointer "
                      style={{ color: primaryColour }}
                    >
                      <MdOutlineSupportAgent className="w-[18px] h-[18px] mr-[0.3rem]" />
                    </span>}
                   {fButtonSelection?.name === "Link" && <span
                      className="my-auto cursor-pointer "
                      style={{ color: primaryColour }}
                    >
                      <LuMonitorPlay className="w-[18px] h-[18px] mr-[0.3rem]" />
                    </span>}
                    {sButtonSelection?.name === "Calendar" && <span
                      className="my-auto cursor-pointer mr-auto"
                      style={{ color: primaryColour }}
                    >
                      <LuCalendarDays className="w-[18px] h-[18px] mr-[0.3rem]" />
                    </span>}
                   {sButtonSelection?.name === "Contact" && <span
                      className="my-auto cursor-pointer mr-auto"
                      style={{ color: primaryColour }}
                    >
                      <MdOutlineSupportAgent className="w-[18px] h-[18px] mr-[0.3rem]" />
                    </span>}
                    {sButtonSelection?.name === "Link" && <span
                      className="my-auto cursor-pointer mr-auto"
                      style={{ color: primaryColour }}
                    >
                      <LuMonitorPlay className="w-[18px] h-[18px] mr-[0.3rem]" />
                    </span>}
                    {sButtonSelection?.name === "None" && <span
                      className="my-auto cursor-pointer mr-auto"
                      style={{ color: primaryColour }}
                    >
                      {/* <LuMonitorPlay className="w-[18px] h-[18px] mr-[0.3rem]" /> */}
                    </span>}
                  </div>
                </div>
                {/* Send Bar */}
                
               

              </div>
            ) : (
              <div className="pl-4 ">
                <div
                  className={`${
                    !mobileView
                      ? "h-[300px] sm:h-[300px] md:h-[450px] lg:h-full"
                      : "h-[300px] sm:h-[300px] md:h-[400px] lg:h-[400px]"
                  } overflow-y-auto relative`}
                >
                  {!mobileView ? (
                    <img
                      src={designScreenshot?.desktop_view}
                      className="w-[100%] mx-auto"
                    />
                  ) : (
                    <img
                      src={designScreenshot?.mobile_view}
                      className="w-[100%] mx-auto"
                    />
                  )}
                  <div
                    style={{ backgroundColor: chatBubbleData?.bubbleColour }}
                    className={`${
                      !mobileView
                        ? "bottom-2 w-10 h-10 sm:w-8 sm:h-8"
                        : "bottom-2 w-10 h-10  sm:w-8 sm:h-8"
                    } absolute right-4 mt-2  text-white rounded-[100%] text-center cursor-pointer py-2 flex`}
                  >
                    <BsChatLeftText className="text-black text-md mx-auto my-auto"></BsChatLeftText>
                  </div>
                </div>
                {/* <div className='w-[90%] sm:w-[35%] absolute bottom-[25%] lg:bottom-[18%] md:bottom-[22%] sm:bottom-[30%]  right-[7%] md:right-[9%] sm:right-[12%]'>
  <ChatbotResponsive/>
  </div> */}
              </div>
            )}
          </div>}
          {/* AMA preview */}

        </div>
      </div>
      {/* Right Screen */}
      {/* Container */}
      <Transition.Root show={embeddModal} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => {
            setEmbeddModal(false);
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          Embed Code
                        </Dialog.Title>
                        <p>
                          Please embed the script generated below according to
                          your specifications into your website.
                        </p>
                        <div className="mt-2">
                          <div className="w-full flex bg-gray-200 rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                            <textarea
                              disabled
                              rows="3"
                              type="text"
                              name="placeholderText"
                              id="placeholderText"
                              className="block resize-none text-orange-600 w-full border-0 p-0 bg-gray-200 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                              // placeholder="Enter"
                              value={embeddCode}
                            />
                            <Clipboard
                              className="ml-auto cursor-pointer"
                              onClick={handleClipboard}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                        onClick={async () => {
                          handleMultipleDelete();
                          setSelectedConversation([]);
                          deleteHandleClose();
                        }}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        onClick={() => deleteHandleClose(false)}
                        ref={cancelButtonRef}
                      >
                        No
                      </button>
                    </div> */}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Cropper Modal */}
      <Transition.Root show={cropModal} as={Fragment}>
      <Dialog className="relative z-10" onClose={()=>{setCropModal(false);setPreview(null);setPromptNumber("")}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                {!preview &&
                <div className="px-4 pb-2  flex flex-col">
                  <div className="mb-4 font-bold text-lg">Upload Image</div>
                  <input type="file"  onChange={handleImageChange}/>
                </div>
                }
                {preview && 
                <div className="py-1 px-2 flex flex-col">
                  <div className="mb-4 font-bold text-lg">Crop Image</div>

<div className="relative w-[300px] h-[200px] mx-auto">

                  <Cropper
            image={preview}
            crop={crop}
            // rotation={rotation}
            // zoom={zoom}
            aspect={4 / 4}
            onCropChange={setCrop}
            // onRotationChange={setRotation}
            onCropComplete={onCropComplete}
            // onZoomChange={setZoom}
            // cropSize={{ height: 200, width: 200 }}
          />
</div>
          <div className="mt-4 ml-auto cursor-pointer text-[#49BCD2] font-[600]" onClick={showCroppedImage}>Submit</div>
                </div>
        }
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
      {/* Cropper Modal */}
      {showPopup && (
        <div className="popupCar">
          <img src={imageSrc} alt="Popup Image" />
        </div>
      )}
    </>
  );
};

export default ChatDesign;
